module.exports = __webpack_public_path__ + "static/media/11_l_stul_8_07_80.65.7a024be2.png";